module.exports = __webpack_public_path__ + "img/i-analytical-content-admin.8be11109.svg";